export default __webpack_public_path__ + "static/media/notificationIcon.8ccf5139.svg";